<template>
  <!-- A component showing a textarea to allow feedback from users -->
  <div id="mainContainer">
    <h1>{{pageText.title[selectedLang]}}</h1>
    <!-- Where users can type what they want -->
    <div id="formContainer">
      <label>{{pageText.form.label[selectedLang]}}</label>
      <div id="textAreaContainer">
        <textarea v-model="userText"/>
      </div>
      <div id="buttonContainer">
        <button class="btn btn-primary" v-on:click="submit()">{{pageText.form.button[selectedLang]}}</button>
      </div>
    </div>
    <!-- Where thankful or failure messages are shown -->
    <div id="answerContainer" v-if="requestSent">
      <p v-if="!encounterError">{{pageText.answer.thanks[selectedLang]}}</p>
      <p v-if="encounterError">{{errorMessage}}</p>
    </div>
  </div>
</template>

<script>
import {submitSuggestion} from '../utils.js'

export default {
  name: 'Suggestions',
  data () {
    return {
      // Static text on the page available
      // in french, english and dutch
      pageText : {
        title : {
          en : "Suggestions",
          fr : "Suggestions",
          nl : "Suggesties"
        },
        form : {
          label : {
            en : "If you have any suggestion, please let us know : ",
            fr : "Si vous avez une suggestion, faites-le nous savoir : ",
            nl : "Als u een suggestie heeft, laat het ons dan weten: "
          },
          button : {
            en : "Submit",
            fr : "Envoyer",
            nl : "Indienen"
          }
        },
        answer : {
          thanks : {
            en : 'Thank you for your suggestions !',
            fr : 'Merci pour vos suggestions !',
            nl : 'Dank u voor uw suggesties !'
          }
        }
      },
      // What user types
      userText : "",
      // Tells if user has sent his message yet 
      requestSent : false,
      // Message in case of error
      errorMessage : "",
      // Tells if an error has been reached
      encounterError : false
    }
  },
  props : {
    selectedLang : String
  },
  methods : {
    /**
     * Function triggered when user sends his feedback
     */
    submit(){
      submitSuggestion(this.userText, this.selectedLang, (_) => {
        // In case of success, thanks the user for his help 
        this.encounterError = false;
        this.requestSent = true
        this.userText = ""
      }, (e) => {
        // In case of error, show the error message instead
        this.encounterError = true;
        this.requestSent = true;
        this.errorMessage = e;
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

h1 {
  text-align: center;
  font-size: 2vw;
}

#mainContainer {
  width: 100%;
  height: 97%;
}

#formContainer{
  width: 80%;
  height: 40%;
  margin: auto;
}

label {
  font-weight: bold;
  font-size: 0.7vw;
}

#textAreaContainer {
  height: 70%;
}

textarea {
  width: 100%;
  height: 100%;
}

#buttonContainer {
  width: 10%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 2%;
}

input {
  width: 100%;
  font-size: 0.9vw;
}

#answerContainer {
  width: 100%;
  height: 30%;
  margin-top: 4%;
}

p {
  text-align: center;
  font-weight: bold;
}

@media screen and (max-width: 850px) {
  #mainContainer {
    height: auto;
  }

  #textAreaContainer {
    height: 25vh;
  }

  h1 {
    font-size: 10vw;
  }

  label {
    font-size: 3vw;
  }

  input {
    font-size: 3vw;
  }

  #buttonContainer {
    width: 40%;
  }
}

@media screen and (max-width: 850px) and (orientation : landscape){
  h1 {
    font-size: 5vw;
  }

  input {
    font-size: 2vw;
  }

  #formContainer {
    width: 95%;
    text-align: center;
  }

  label {
    font-size: 2vw;
  }
}
</style>
